export const TRANS_SLUG_MAP: Record<string, string> = {
  elegant_stylish: 'morgan-baiad1',
  athletic_colorful_hair: 'skye-rivers',
  glamorous_coquette: 'viera-lux',
  natural_beauty_no_makeup: 'ember-vale',
};
